import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { fetchYardsApi } from '../../services/api';
import { servicioReporteTiempoXPuntosControl } from '../../services/Reportes/ServicesReports';
import { Cargando } from '../../components/Cargando';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Cell } from 'recharts';

export default function ReporteTiempoPromedioXPuntosControl() {
  const { token } = useAuth();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [yardId, setYardId] = useState('');
  const [yards, setYards] = useState([]);

  const [loadingYards, setLoadingYards] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const colorPoints = ['#007bff', '#dc3545', '#FFC107', '#6c757d', '#28a745', '#6f42c1', '#17a2b8', '#6f42c1', '#28a745', '#6f42c1'];

  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      setLoadingYards(true);
      setErrorMsg('');
      try {
        const list = await fetchYardsApi({ token });
        setYards((list || []).sort((a, b) => a.nombre.localeCompare(b.nombre)));
      } catch (err) {
        console.error(err);
        setErrorMsg('No se pudieron cargar los patios.');
      } finally {
        setLoadingYards(false);
      }
    })();
  }, [token]);

  const dataChart = useMemo(() => {
    return (rows || []).map((r) => ({
      name: r.controlPoint || 'Punto',
      minutes: Number(r.avgMinutes ?? (Number(r.avgSeconds || 0) / 60)),
    }));
  }, [rows]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setRows([]);

    if (!yardId || !startDate || !endDate) {
      setErrorMsg('Seleccione patio y rango de fechas.');
      return;
    }

    setLoading(true);
    try {
      const res = await servicioReporteTiempoXPuntosControl({ startDate, endDate, yardId, token });
      console.log(res);
      const arr = Array.isArray(res) ? res : (Array.isArray(res?.value) ? res.value : []);
      setRows(arr);
    } catch (err) {
      console.error(err);
      setErrorMsg('No se pudo obtener el reporte.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Tiempo promedio por Punto de Control</h4>

      <div className="card">
        <div className="card-body">
          <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-4">
                <label className="form-label">Patio</label>
                <select
                  className="form-select"
                  value={yardId}
                  onChange={(e) => setYardId(e.target.value)}
                  disabled={loadingYards}
                >
                  <option value="">-- Selecciona --</option>
                  {yards.map((y) => (
                    <option key={y.id} value={y.id}>{y.nombre}</option>
                  ))}
                </select>
                {loadingYards && <div className="form-text">Cargando patios...</div>}
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha inicio</label>
                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha fin</label>
                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </div>

              <div className="col-12">
                <button type="submit" className="btn btn-primary" disabled={loading || loadingYards}>
                  {loading ? 'Consultando...' : 'Consultar'}
                </button>
              </div>
            </div>
          </form>

          {errorMsg && <div className="alert alert-danger mt-3">{errorMsg}</div>}

          <div className="mt-3">
            {loading && <Cargando />}

            {!loading && rows.length > 0 && (
              <div className="row g-3 justify-content-center">
                <div className="col-12 col-lg-10">
                  <div className="border rounded p-3" style={{ height: 500 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart data={dataChart} margin={{ top: 20, right: 20, bottom: 40, left: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" interval={0} angle={-20} textAnchor="end" height={60} />
                        <YAxis allowDecimals={false} label={{ value: 'Minutos', angle: -90, position: 'insideLeft' }} />
                        <Tooltip formatter={(v) => `${Number(v).toFixed(2)}`} />
                        <Bar dataKey="minutes" fill="#0d6efd" barSize={100-200}>
                          {dataChart.map((entry, index) => (
                            <Cell key={index} fill={colorPoints[index]} />
                          ))}
                          <LabelList dataKey="minutes" position="top" formatter={(v) => Number(v).toFixed(1)} />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            )}

            {!loading && rows.length === 0 && !errorMsg && (
              <div className="text-muted">Sin resultados. Cambia los filtros y vuelve a consultar.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
